// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__S5a_S","list":"PatternAutocomplete_list__WjC0v"};